export default "__VITE_ASSET__Cdr73Vi8__"